import { browserHistory } from 'react-router';

import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import SavedJobsAPI from '../util/SavedJobsAPI';
import SavedJobsStore from '../stores/SavedJobsStore';

import TokenStore from '../stores/TokenStore';
import CurrentOrganizationIdStore from '../stores/CurrentOrganizationIdStore';

const shapeSavedJobForCloning = (savedJob) => {
  const clonedJob = savedJob.set('id', undefined)
                            .set('runAsUserEmail', undefined)
                            .set('scheduleId', undefined)
                            .set('scheduleCron', undefined)
                            .set('name', `COPY OF ${savedJob.name}`);
  return clonedJob;
};

const SavedJobActions = {
  create(name, organizationId, config) {
    const requestJson = { name, organizationId, config };
    new SavedJobsAPI(TokenStore.getToken()).savedjobs.createJob(organizationId, requestJson)
      .then((response) => {
        const job = response.message;
        AppDispatcher.dispatch({
          actionType: Constants.SavedJobs.JOB_CREATED,
          job,
        });
        browserHistory.push(`/savedjobs/${job.id}`);
      });
  },

  get(savedJobId) {
    const api = new SavedJobsAPI(TokenStore.getToken()).savedjobs;

    api.getJob(savedJobId).then((savedJob) => {
      api.getSchedule(savedJobId).then((scheduleResponse) => {
        AppDispatcher.dispatch({
          actionType: Constants.SavedJobs.JOB_RECEIVED,
          savedJob,
          schedule: scheduleResponse.message.schedulableJob,
        });
      });
    });
  },

  update(currentSavedJob, newSavedJob) {
    const hasEmptySchedule = savedJob => !savedJob.runAsUserEmail && !savedJob.scheduleCron;

    const api = new SavedJobsAPI(TokenStore.getToken()).savedjobs;

    const scheduleJson = {
      id: newSavedJob.scheduleId,
      savedJobId: newSavedJob.id,
      userEmail: newSavedJob.runAsUserEmail,
      cronExpression: newSavedJob.scheduleCron,
    };

    const scheduleRequest = () => {
      if (hasEmptySchedule(newSavedJob)) {
        return api.deleteSchedule(newSavedJob.id);
      } else if (hasEmptySchedule(currentSavedJob)) {
        return api.createSchedule(newSavedJob.id, scheduleJson);
      }
      return api.updateSchedule(newSavedJob.id, scheduleJson);
    };

    api.updateJob(newSavedJob.id, newSavedJob.toJS()) // TK this is not returning a promise?
      .then(() => {
        scheduleRequest().then((response) => {
          AppDispatcher.dispatch({
            actionType: Constants.SavedJobs.JOB_UPDATED,
            savedJob: newSavedJob.toJS(),
          });
          return response;
        });
      });
  },

  delete(savedJobId) {
    new SavedJobsAPI(TokenStore.getToken()).savedjobs.deleteJob(savedJobId).then(() => {
      AppDispatcher.dispatch({
        actionType: Constants.SavedJobs.JOB_DELETED,
        savedJobId,
      });
    });
  },

  launch(savedJobId, optionsPayload = undefined) {
    new SavedJobsAPI(TokenStore.getToken()).savedjobs
      .launchSavedJob(savedJobId, optionsPayload)
      .then((jobId) => {
        AppDispatcher.dispatch({
          actionType: Constants.SavedJobs.SAVED_JOB_LAUNCHED,
          jobId,
        });
        browserHistory.push('/jobs');
      });
  },

  getSavedJobsForCurrentOrganization() {
    this.getSavedJobs(CurrentOrganizationIdStore.getState());
  },

  getSavedJobs(organizationId) {
    new SavedJobsAPI(TokenStore.getToken()).savedjobs.getSavedJobsForOrg(organizationId)
      .then((savedJobs) => {
        AppDispatcher.dispatch({
          actionType: Constants.SavedJobs.RECEIVE_SAVED_JOBS,
          savedJobs,
        });
      });
  },

  clone(savedJobId) {
    AppDispatcher.dispatch({
      actionType: Constants.NewJob.NEW_JOB_REQUESTED,
      savedJob: shapeSavedJobForCloning(SavedJobsStore.get(savedJobId)),
    });
    browserHistory.push('/jobs/new');
  },
};

export default SavedJobActions;
